import { styled, ty } from '@gcc/autobahn-components';

const StyledContentBox = styled.div`
  ${ty`w-100 relative overflow-visible-s bg-white f6`}
`;

export default StyledContentBox;
